"use client";

import { c as _c } from "react/compiler-runtime";
import type { DropInteractionParams } from "@/components/waves/drops/Drop";
import Drop, { DropLocation } from "@/components/waves/drops/Drop";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { convertApiDropToExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ActiveDropState } from "@/types/dropInteractionTypes";
import type { ReactNode } from "react";
import CompactDropPreview from "./CompactDropPreview";
function wrapDropContentInCompact(content: ReactNode) {
  return <CompactDropPreview>
      <div className="tw-w-full tw-min-w-0">{content}</div>
    </CompactDropPreview>;
}
interface NotificationDropProps {
  readonly drop: ApiDrop;
  readonly activeDrop: ActiveDropState | null;
  readonly onReply: (param: DropInteractionParams) => void;
  readonly onReplyClick: (serialNo: number) => void;
  readonly onQuoteClick: (quote: ApiDrop) => void;
  readonly onDropContentClick?: ((drop: ExtendedDrop) => void) | undefined;
}
export default function NotificationDrop(t0) {
  const $ = _c(9);
  const {
    drop,
    activeDrop,
    onReply,
    onReplyClick,
    onQuoteClick,
    onDropContentClick
  } = t0;
  let t1;
  if ($[0] !== drop) {
    t1 = convertApiDropToExtendedDrop(drop);
    $[0] = drop;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const extendedDrop = t1;
  let t2;
  if ($[2] !== activeDrop || $[3] !== extendedDrop || $[4] !== onDropContentClick || $[5] !== onQuoteClick || $[6] !== onReply || $[7] !== onReplyClick) {
    t2 = <Drop drop={extendedDrop} previousDrop={null} nextDrop={null} showWaveInfo={true} showReplyAndQuote={true} activeDrop={activeDrop} location={DropLocation.MY_STREAM} dropViewDropId={null} onReply={onReply} onReplyClick={onReplyClick} onQuoteClick={onQuoteClick} onDropContentClick={onDropContentClick} wrapContentOnly={wrapDropContentInCompact} />;
    $[2] = activeDrop;
    $[3] = extendedDrop;
    $[4] = onDropContentClick;
    $[5] = onQuoteClick;
    $[6] = onReply;
    $[7] = onReplyClick;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}